const en = {
  common: {
    lang: 'Language',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    confirm: 'Confirm',
    cancel: 'Cancel',
    updatePwd: 'Password',
    logout: 'Logout',
    emptyText: 'No Data',
    confirmInfo: 'Confirmation',
    imgFormatVerify: 'Only .jpg/.png/.jpeg format images can be uploaded!',
    imgSizeVerify: 'Upload image size can not exceed 200KB!',
    loading: 'Loading...',
  },
  login: {
    title: 'Sign in',
    titleBtn: 'Sign in',
    or: 'Or',
    scanSuccess: 'Scan successful !',
    codeExpired: 'The QR code has expired',
    retryText: 'Please get back',
    retry: 'Retry',
    scanWechat: 'Scan Wechat public account and log in',
    forgetPassword: 'Reset password',
    password: 'password',
    phoneOrEmail: 'user name',
    loginLoading: 'Loading',
    loginAccount: 'Log in with your account number and password',
    accountTip: 'Please fill in the user name',
    pwdTip: 'Please fill in the password',
    pwdErrorTip: 'Wrong password, please check the account number or password',
    accountNotExistTip: 'The user does not exist. Please check your account or password',
    firstLoginText: 'Please login with your account number and password for the first time',
    agreementAgree: 'I have read and agreed to the agreement.',
    agreementTip: 'Please read and agree to the agreement',
    agreementContent: `<p><strong>2023-2024 Year AP Exam</strong></p>
    <p><strong>PERSONAL DATA PRIVACY DISCLOSURE &amp; CONSENT</strong></p>
    <p>
      At Prometric, protection of your personal data and information, and making sure you understand how and why it is
      processed, is of paramount importance to us. As a data processor for your test sponsor, Prometric processes your personal
      information only for the purposes of registering and scheduling you for a test, administering that test, and processing
      the results. At no time will your personal information be used by Prometric for any other purpose without your permission.
      Your personal information, including your test results, will be provided to your test sponsor for the purposes of
      providing scores, certification, or other test-related services. The full Prometric Privacy Policy, including instructions
      for submitting a data subject request, can be found at www.prometric.com/privacy-policy.
    </p>
    <p>
      We may employ other companies and individuals to perform functions on our behalf. Our employees, agents and contractors
      who have access to personal data and information are required to protect the information in a manner that is consistent
      with the Prometric Privacy Policy and upholds the confidentiality of the information and the rights of data subjects, and
      we seek assurances from such third parties that they will provide the same level of privacy protection as Prometric
      requires of its employees and adheres to, including in regards to applicable data protection law. We do not transfer
      information to third parties who are not acting as Prometric's agent or on Prometric's behalf under an appropriate
      contractual relationship.
    </p>
    <p>
      Prometric LLC is headquartered in the United States of America. Personal data of domestic U.S. and international
      candidates will be accessed from or transferred to the United States for processing and storage, but our affiliates and
      data processors located elsewhere in the world may have access to the data to facilitate the purposes outlined in the
      first paragraph herein. “International candidates” are candidates or employees residing outside of the United States on a
      permanent basis who do not hold a United States passport. Prometric will always protect the privacy and security of
      personal data, regardless of the location of the individual where it is originally collected or ultimately processed or
      stored. Personal Data that is collected and processed from you, the data subject and/or exam candidate, is authorized
      through your application or contract with your test sponsor to take an exam, your registration and scheduling through
      Prometric, and the collection of your express consent by login below.
    </p>
    <p>
      Prometric maintains certification to the EU/U.S. Privacy Shield as well as the Swiss/U.S. Privacy Shield for the purposes
      of transfers of Personal Data from the European Economic Area; however, we also rely on standard contractual clauses
      between Prometric’s European-based entities and its entities located elsewhere in the world that process personal
      information, and we also enter into data processing agreements with our clients and vendors. At any time, you may request
      access, rectification, erasure, portability, restriction, or object to the processing of your Personal Data, or make
      inquiries, requests, complaints, or withdraw consent related thereto by contacting your test sponsor during normal
      business hours. You may also submit a Data Subject Access Request directly to Prometric at
      www.prometric.com/datasubjectrequests.
    </p>
    <p><strong>VIDEO &amp; AUDIO MONITORING</strong></p>
    <p>
      In Test Centers, Prometric deploys Digital Video Recording (DVR or CCTV) throughout its network of test delivery
      locations. Where allowed by applicable law this includes audio-recordings within the reception/locker, proctor/security
      check-in, and test lab areas. This is necessary in order to protect the security of high-stakes proprietary test content,
      the integrity of the test delivery experience, to deter fraud and cheating, to protect against theft and pilferage, and
      for the security of staff and company property. Access to the recorded material will be strictly limited to authorized
      personnel and retained for a period as allowed by local applicable law.
    </p>
    <p>
      The collection, transfer, processing, use and storage of your Personal Data is necessary to administer a test to you. You
      must contact your test sponsor if you do not consent to the collection, transfer, processing, use and storage of your
      Personal Data.
    </p>
    <p>
      By proceeding to register and schedule your test today, you acknowledge, agree and consent to the audio and video
      recording of your test experience. You acknowledge and agree to be monitored during the testing session in real time and
      recorded during the testing session, and acknowledge and agree that there is no right to privacy during the test check-in
      process or test session and explicitly waive any and all claims asserting a right to or violation of your privacy with
      regards thereto.
    </p>
    <p>
      <strong>
        I confirm that I am at least 18 years of age, or that I am the parent or guardian of the data subject and/or exam
        candidate, and that I am authorized to make the consent election required below regarding the collection and processing
        of personal data.
      </strong>
    </p>
    <p>
      <strong>
        I acknowledge that by login below that I am expressly consenting to the collection and processing of my Personal Data,
        as required by my test sponsor, which may include video and audio-recordings and/or biometric data and assessment
        results, and that such consent is effective until and unless I affirmatively withdraw that consent in writing to my test
        sponsor or via www.prometric.com/datasubjectrequests.
      </strong>
    </p>
    <p>&nbsp;</p>`,
    loginClickTips: 'Sorry, you click too often, please rest for 3 seconds and try again!',
    register: 'No account? Register now',
    loginBottomTips1: 'Non-Affiliated Student register to take the AP exam. Please first review the ',
    loginBottomTips2: 'registration instructions',
    loginBottomTips2Split: ',',
    loginBottomTips3: 'the AP student guide,',
    loginBottomTips4: 'the payment instructions,',
    loginBottomTips5: 'then',
    loginBottomTips6: 'create a user account',
    loginBottomTips7: 'to begin registration.',
    loginBottomTips8: 'Please note: If you do not have an AP Profile account, please click',
    loginBottomTips9: 'here',
    loginBottomTips10: 'to create an account.',
    loginBottomTipsAnd: 'and',
    loginBottomTipsWX: 'If you have bound your WeChat account, click the scan code to log in',
  },
  homeIndex: {
    createWorkOrder: 'CREATE WORK ORDER',
    edit: 'EDIT',
    bindWX: 'BIND WECHAT',
    print: 'PRINT ADMISSION TICKET',
    createEnroll: 'CREATE ENROLLMENT',
    save: 'SAVE',
    save400ErrorTips: 'Personal information saving failed, please try again. If you have any questions, please contact the registration center for help.',
    cancel: 'CANCEL',
    seeLogs: 'VIEW CHANGE LOG',
    school: 'School',
    examCenter: 'Test city',
    lastNameCHS: 'Legal Last Name CHS',
    lastNameCHSPlaceHolder: 'Please fill in the Legal Last Name CHS',
    lastNameCHSFormatPlaceHolder: 'Input Chinese.',
    firstNameCHS: 'Legal First Name CHS',
    firstNameCHSPlaceHolder: 'Please fill in the Legal First Name CHS',
    lastNameEN: 'Legal Last Name',
    lastNameENPlaceHolder: 'Please fill in the Legal Last Name',
    lastNameENFormatPlaceHolder: 'Input alphabetic characters, first letter must be uppercase.',
    firtNameEN: 'Legal First Name',
    firtNameENPlaceHolder: 'Please fill in the Legal First Name',
    government_id_type: 'Government ID Type',
    government_id_typePlaceHolder: 'Please select the Government ID Type',
    government_id: 'Government ID',
    government_idPlaceHolder: 'Please fill in the Government ID',
    government_idFormatPlaceHolder: 'Wrong ID format.',
    government_idCorrectSexPlaceHolder: 'The Government ID does not match the Gender, please check',
    government_idCorrectBirthPlaceHolder: 'The Government ID does not match the Date of Birth, please check',
    cardTitle1: 'AP Profile Info',
    cardTitle2: 'Photo for ID',
    cardTitle3: 'Eligibility',
    cardTitle4: 'Roster',
    cardTitle5: 'Work Orders',
    sex: 'Gender',
    sexPlaceHolder: 'Please select the Gender',
    male: 'Male',
    female: 'Female',
    birthday: 'Date of Birth',
    birthdayPlaceHolder: 'Please select the Date of Birth',
    emailAddr: 'Email Address',
    phone1: 'Mobile Phone 1',
    phone2: 'Mobile Phone 2',
    phone1PlaceHolder: 'Please fill in the Mobile Phone 1',
    phone2PlaceHolder: 'Please fill in the Mobile Phone 2',
    phoneCorrectPlaceHolder: 'Please fill in your mobile phone number correctly',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    address3: 'Address Line 3',
    addressPlaceHolder: 'Please fill in the Address',
    addressFormatPlaceHolder: 'Use alphanumeric and . , - / # character only.',
    postal_code: 'Postal Code',
    postal_codePlaceHolder: 'Please fill in the Postal Code',
    postal_codeFormatPlaceHolder: 'Input China mainland zip code, 6 digits.',
    province: 'Province',
    provincePlaceHolder: 'Please select the Province',
    city: 'City',
    cityPlaceHolder: 'Please select the City',
    grade: 'Grade',
    gradePlaceHolder: 'Please select the Grade',
    languagePre: 'Preferred Language',
    languagePrePlaceHolder: 'Please select the Preferred Language',
    parent_education_level: 'Parent/Guardian 1 Education Level',
    parent_education_levelPlaceHolder: 'Please select the Education Level',
    parent2_education_level: 'Parent/Guardian 2 Education Level',
    photo: 'ID Photo',
    photoPlaceHolder: 'Please uoload the ID Photo',
    photo_qualified: 'ID Photo Qualified',
    photo_status: 'ID Photo Status',
    eligibility_id: 'Eligibility ID',
    registration_link: 'Registration Link',
    roster_name: 'Name',
    roster_date: 'Exam Date',
    roster_order_status: 'Order Status',
    roster_confirmation: 'Confirmation #',
    roster_enroll_status: 'Enroll Status',
    orders_id: 'Number',
    orders_subject: 'Subject',
    orders_resolution: 'Processing Results',
    orders_process: 'Status',
    orders_date_created: 'Date Created',
    orders_last_modified: 'Last Modified',
    modifyTips: 'Modify successfullly!',
    modifyErrorTips1: 'Saving failed，ID number already exists',
    msgText: 'Work Order Reply',
    msgTips: 'You have new work order reply, please go and view~',
    signResultTitle: 'Enrollment Result',
    signSubject: 'Subject',
    signSubjectStatus: 'Status',
    signSubjectDesc: 'Description',
    birthdayCorrectPlaceHolder: 'The date of birth must meet the application requirements.'
  },
  createWorkOrderModal: {
    title: 'Create Work Order',
    subject: 'Subject',
    desc: 'Problem Description',
    attachment: 'Attachment',
    attachmentPasteHint: 'Ctrl+V to paste images or files',
    attachmentUploadTip: 'Click to upload',
    attachmentCountHint: '{current}/{max}',
    attachmentMaxCount: 'Maximum 5 attachments per work order',
    attachmentMaxTotalSize: 'Total attachment size cannot exceed 50MB',
    attachmentMaxSingleSize: 'Single attachment size cannot exceed 10MB',
    attachmentMaxImageSize: 'Single image size cannot exceed 5MB',
    attachmentFormatError: 'Allowed formats: jpg, jpeg, png, webp, pdf, doc, docx, xls, xlsx, pptx, txt, zip',
    attachmentForbiddenFormat: 'Forbidden formats: exe, bat, cmd, sh, js, html, php, jar',
    attachmentUploadingBlock: 'Attachments are still uploading. Please wait before submitting.',
    attachmentUploadRetry: 'Upload failed. Click to retry',
    attachmentRetryShort: 'Retry',
    attachmentUploading: 'Uploading',
    attachmentPreviewTitle: 'File Preview',
    attachmentPreviewError: 'Preview failed. Please download the file to view it.',
    attachmentPreviewUnsupported: 'Online preview is not supported for this format',
    subjectPlaceholder: 'Please fill in the subject',
    descPlaceholder: 'Please fill in the problem description',
    createTips: 'Work order created successfully!',
    replyTips: 'Reply successful!',
    user: 'User',
    customerService: 'Customer Service',
    bottomTips1: 'Work Order processing is not a real-time dialogue, please wait for customer service reply',
    bottomTips2: 'For immediate assistance, please',
    bottomLink: 'contact us',
  },
  modifyLogModal: {
    title: 'Change Log',
    tips: `Fields audited in this module: Assigned User Id, Email Address, Address Line 2, Address Line 3, Mobile Phone 2, Address Line 1, Date of Birth, Government ID, Legal First Name, Legal First Name CHS, Legal Last Name, Legal Last Name CHS, Mobile Phone 1, Postal Code, Parent/Guardian 2 Education Level, Government ID Type, Grade, Parent/Guardian 1 Education Level, Preferred Language, Province, City, Gender, ID Photo`,
    field: 'Field',
    old_value: 'Old Value',
    new_value: 'New Value',
    changed_by: 'Changed By',
    change_date: 'Change Date',
  },
  modifyPwd: {
    title: 'Change Password',
    newPwd: 'New Password',
    newPwdPlaceholder: 'Please fill in the New Password',
    tips: 'Password changed successfully!',
  },
  forgetPwd: {
    title: 'Reset Password',
    newPwd: 'New Password',
    newPwdPlaceholder: 'Please fill in the New Password',
    newPwdFormatPlaceholder: 'Only alphanumeric combinations are allowed, with a minimum of 8 bits',
    confirmPwd: 'Confirm Password',
    confirmPwdPlaceholder: 'Please fill in the Confirm Password',
    confirmPwdFormatPlaceholder: 'Make sure you enter the same password twice',
    email: 'Email Address',
    emailPlaceholeder: 'Please fill in the Email Address',
    code: 'Verification Code',
    getCode: 'Get Verification Code',
    codePlaceholder: 'Please fill in the Verification Code',
    tips: 'Password reset successful!',
    // expiredTips: 'Verification Code has expired',
    expiredTips: 'Invalid Verification Code',
    accountTips: 'Account does not exist!',
    againTips: 'Obtaining verification codes frequently, please try again later',
  },
  register: {
    title: 'New user registration',
    subtitleBold: 'This registration is only for [independent candidates].',
    subtitle1: 'Please visit the AP China website',
    subtitle1Split: 'for this year’s AP exam registration policy, process, and guidance.',
    subtitle2: 'Students whose schools offer AP courses should have accounts created by their schools. Please do not create a login account on your own.',
    subtitle3: 'Please fill in the information below to create your account. Personal details cannot be changed after submission.',
    sectionAccount: 'Account',
    sectionProfile: 'Personal Information',
    sectionPassword: 'Set Password',
    hasAccount: 'Already have an account?',
    toLogin: 'Back to Login',
    email: 'Email',
    emailPlaceholder: 'Please fill in the Email Address, the email address must be the same as the AP Profile account',
    authCode: 'Validation Code',
    authCodePlaceholder: 'Please fill in the Validation Code',
    authCodeTips: 'Validation Code sent successfully!',
    authCodeErrTips1: 'Invalid Validation Code',
    authCodeErrTips2: 'Obtaining verification codes frequently, please try again later',
    authCodeErrTips3: 'Email address already registered, please do not repeat the creation.',
    getAuthCode: 'Get Verification Code',
    testCenter: 'Test Center City',
    testCenterPlaceholder: 'Select the city where you will take the exam. It cannot be changed after registration.',
    school: 'High School',
    schoolPlaceholder: 'Please enter the high school name or the name of the school where you are enrolled',
    pwd: 'Password',
    pwdPlaceholder: 'Please fill in the Password',
    confirmPwd: 'Confirm Password',
    confirmPwdPlaceholder: 'Please fill in the Confirm Password',
    pwdValidTips1: 'Please fill in the Password',
    pwdValidTips2: 'Password length must be at least 8 characters',
    pwdValidTips3: 'Password must contain letters and numbers',
    pwdValidTips4: 'Passwords do not match',
    emailValidTips1: 'Please fill in the Email Address',
    emailValidTips2: 'Please fill in the correct Email Address format',
    testCenterValidTips: 'Please select the Test City',
    registerTips: 'Registration successful!',
    registerErrTips1: 'Verification Code Expired',
    registerErrTips2: 'Invalid Verification Code',
    lastName: 'Legal Last Name',
    lastNamePlaceholder: 'Please fill in the Legal Last Name, the last name must be the same as the AP Profile account',
    firstName: 'Legal First Name',
    firstNamePlaceholder: 'Please fill in the Legal First Name, the first name must be the same as the AP Profile account',
    grade: 'Grade',
    gradePlaceholder: 'Please select the Grade',
    btn: 'Create user account',
    confirmInfoTips: 'Personal information cannot be modified after submission. Please confirm your information.',
  },
  selectSubject: {
    title: 'Select Exam Subject',
    examName: 'Subject Name',
    testDate: 'Test Date',
    tips1: 'Please refer to',
    tips2: 'registration instructions',
    tips3: 'Learn about the current year the AP exam registration requirements.',
    tips4: 'Students can only register for either AP Calculus AB or AP Calculus BC in the same year, but not both.',
    selectTips: 'Please select at least one subject',
    selectTips2: 'Please select AP Calculus AB or AP Calculus BC',
  },
}
export default en
